import React from 'react';
import { useNavigate } from 'react-router-dom';

const AboutSection = () => {
  const navigate = useNavigate();

  const handleSubmit = (event) => {
    event.preventDefault(); // Prevent the default form submission behavior
    // Here you can add form validation and submission logic if needed
    navigate('/thankyou'); // Redirect to the "Thank You" page
  };

  return (
    <section id="about" className="about">
      <div className="container" data-aos="fade-up">
        <div className="row content">
          <div className="col-lg-8">
            <h3>With IT Assist Experts as your IT partner, you will get:</h3>
            <ul>
              <li><i className="ri-check-double-line"></i> Proactive Problem Prevention: IT Assist Experts actively monitors and addresses IT concerns before they escalate, ensuring seamless operations and minimal downtime for your business.</li>
              <li><i className="ri-check-double-line"></i> Expertise on Demand: Our seasoned IT professionals are readily available, guaranteeing rapid responses and effective solutions to any tech challenges you face.</li>
              <li><i className="ri-check-double-line"></i> Tailored IT Strategies: We understand that every business is unique. IT Assist Experts crafts customized IT roadmaps that align perfectly with your goals and growth projections.</li>
              <li><i className="ri-check-double-line"></i> Cutting-Edge Solutions: Stay ahead of the curve with the latest technological advancements. We provide our partners with top-tier tools and innovations for sustained competitive advantage.</li>
            </ul>
          </div>
          <div className="col-lg-4 pt-4 pt-lg-0 d-flex align-items-stretch forms">
            <form onSubmit={handleSubmit} id="contactForm" className="php-email-form">
              <div className="row">
                <h4>Get Unlimited IT Assist</h4>
                <p>for as little as $19/month</p>
              </div>
              <div className="inputBox form-group">
                <input type="text" id="name" placeholder="Your name...." required />
              </div>
              <div className="inputBox form-group">
                <input type="email" id="emailid" placeholder="Your Email....." required />
              </div>
              <div className="inputBox form-group">
                <textarea id="phone" cols="0" rows="1" placeholder="Your Phone..." required></textarea>
              </div>
              <div className="inputBox">
                <button type="submit">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
